import React from 'react';
import { Field, connect } from 'formik';
import { injectIntl } from 'react-intl';

import CounterField from '../../components/forms/counter.field.js';

import './people-and-extras.step.scss';

const ExtraItem = ({
	imgSrc, title, notes, description, fieldName, price, max,
}) => (
	<div className="extra-item">
		<div className="extra-content">
			<div className="row">
				<div className="col-xs-12 col-sm-4 col-md-4">
					<img src={imgSrc || 'https://via.placeholder.com/158x158'} alt="" />
				</div>
				<div className="col-xs-12 col-sm-8 col-md-8">
					<div className="extra-item-info">
						<h4 className="extra-item-title">{description}</h4>
						{notes && <h6 className="extra-item-note">{notes}</h6>}
						<h6 className="extra-item-description">{title}</h6>
						<div className="extra-item-subtitle">
							<h4>{`${price}€`}</h4>
						</div>
						<div className="extra-item-counter">
							{max
								? <Field component={CounterField} name={fieldName} maximum={max} />
								: <Field component={CounterField} name={fieldName} />
							}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
);

const PeopleSelectorLabels = ({ title, subTitle }) => (
	<div className="labels-content">
		<div className="title">{title}</div>
		{subTitle && <div className="sub">{subTitle}</div>}
	</div>
);

function amountOfTickets(prices) {
	return prices.reduce((accumulator, currentValue) => accumulator + currentValue.quantity, 0);
}

const PeopleAndExtrasTab = ({
	intl, formik: { values },
}) => (
	<div className="people-and-extras row">
		<div className="col-xs-12">
			<div className="container">
				<div className="people-selector">
					<h3>{intl.formatMessage({ id: 'checkout.people-and-extras.title' })}</h3>
					{values.notes && <h4 className="notes">{values.notes}</h4>}
					<div className="prices">
						{values.prices && values.prices.map((price, index) => (
							<div className="row middle-xs">
								<div className="col-xs-5 col-md-3 labels">
									<PeopleSelectorLabels
										title={price.name}
										subTitle={price.description}
									/>
								</div>
								<Field
									name={`prices[${index}].quantity`}
									component={CounterField}
									className="col-xs-7 col-md-4 middle-xs end-xs start-md"
									minimum={price.minAmount || 0}
									maximum={values.capacity - (amountOfTickets(values.prices) - price.quantity)}
								/>
							</div>
						))}
					</div>
				</div>

				{values.extras && values.extras.length > 0
					&& (
						<div className="extras">
							<h3 className="with-padding-top">
								{intl.formatMessage({ id: 'checkout.people-and-extras.experienceTitle' })}
							</h3>
							{values.extras && values.extras.map((extra, index) => (
								<ExtraItem
									title={extra.description}
									description={extra.name}
									notes={extra.notes}
									price={extra.price}
									imgSrc={extra.image ? extra.image.url : null}
									fieldName={`extras[${index}].quantity`}
									max={extra.capacity}
								/>
							))}
						</div>
					)}
			</div>
		</div>
	</div>
);

export default injectIntl(connect(PeopleAndExtrasTab));
